import { InputHTMLAttributes } from "react";
import s from "./style.module.scss";
import { Icon16Clear, Icon16SearchOutline } from "@vkontakte/icons";
import clsx from "clsx";

interface SearchInputProps extends InputHTMLAttributes<HTMLInputElement> {
  reset?: () => void;
  className?: string;
}
export const SearchInput = ({
  value,
  onChange,
  reset,
  className,
  ...other
}: SearchInputProps) => {
  return (
    <label
      htmlFor="search"
      className={s.inputWrapper}
    >
      <div className={s.before}>
        <Icon16SearchOutline className={s.icons} />
      </div>
      <input
        id="search"
        className={clsx(s.input, className)}
        placeholder="Поиск"
        {...other}
        value={value}
        onChange={onChange}
      />
      <div className={s.after}>
        {value && (
          <button
            className={s.iconButton}
            type="button"
            onClick={reset}
          >
            <Icon16Clear className={s.icons} />
          </button>
        )}
      </div>
    </label>
  );
};
